import React from 'react';

import { useTasks } from '../context/tasks_context';
import SelectFilter from 'components/search_sidebar/select_filter';

import type { SortBy, SortOrder } from '../filters/types';
import { faArrowDownAZ, faArrowUpAZ, type IconDefinition } from '@fortawesome/pro-regular-svg-icons';

type SortOption = {
  label: string;
  value: string;
  icon: IconDefinition;
};

const SORT_OPTIONS: SortOption[] = [
  { label: 'Due Date (Soonest first)', value: 'deadline:asc', icon: faArrowDownAZ },
  { label: 'Due Date (Latest first)', value: 'deadline:desc', icon: faArrowUpAZ },
  { label: 'Task Name (A → Z)', value: 'name:asc', icon: faArrowDownAZ },
  { label: 'Task Name (Z → A)', value: 'name:desc', icon: faArrowUpAZ },
  { label: 'Assigned To (A → Z)', value: 'assignee:asc', icon: faArrowDownAZ },
];

export function TasksSortInput() {
  const { filters, changeFilters } = useTasks();
  const value = SORT_OPTIONS.find(option => option.value === `${filters.sortBy}:${filters.sortOrder}`
  ) || SORT_OPTIONS[0];

  const handleChange = ({ value }: { value: string }) => {
    const selected = SORT_OPTIONS.find(option => option.value === value);
    if (selected) {
      const [sortBy, sortOrder] = selected.value.split(':') as [SortBy, SortOrder];
      changeFilters({ sortBy, sortOrder });
    }
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <span className="fw-semibold">Sort by:</span>
      <SelectFilter
        autoWidth
        icon={value.icon}
        options={SORT_OPTIONS}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}
